import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OperationService } from '../service/operation.service';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['../payment-hub.component.css', './action.component.css']
})
export class ActionComponent implements OnInit {
  tokenId: any;
  walletJson: any;

  constructor(private route: ActivatedRoute, private operationService: OperationService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => console.log(params));

    this.route.queryParams.subscribe(params => {
      this.tokenId = params['token-id'];
      console.log(this.tokenId);
      if (this.tokenId === null || this.tokenId === undefined) {
        return;
      }

      this.operationService.stepthree(this.tokenId).subscribe(
        res => {
          if (res.status != 200) {
            console.log(res.body)
            alert("Failed");
          }
          this.walletJson = res.body;
          console.log(res);
        }, err => {
          console.log(err)
          alert(err.error.message)
        });
    });
  }

}
